import React, { ReactNode } from 'react'
import {
  makeStyles,
  createStyles
} from '@material-ui/core'

export type InlineBlockTypographyProps = {
  children: ReactNode
}

const useStyle = makeStyles(() => createStyles({
  nowrap: {
    display: 'inline-block'
  }
}))

export default function NoWrap ({ children }: InlineBlockTypographyProps) {
  const classes = useStyle()

  return (
    <span className={classes.nowrap}>{children}</span>
  )
}
